import ApiService from "@/core/services/ApiService";
import { Actions } from "@/store/enums/StoreEnums";
import { Module, Action, VuexModule } from "vuex-module-decorators";

@Module
export default class AdminModule extends VuexModule {
  @Action
  async [Actions.TUTORIALS_LIST]() {
    try {
      const response = await ApiService.get("tutorial");
      return Promise.resolve(response);
    } catch (error) {
      this.context.dispatch(Actions.API_ERROR_MESSAGE, error);
      return Promise.reject(error);
    }
  }
  @Action
  async [Actions.TUTORIAL_RETRIEVE](tutorialId) {
    try {
      const response = await ApiService.get("tutorial/" + tutorialId);
      return Promise.resolve(response);
    } catch (error) {
      this.context.dispatch(Actions.API_ERROR_MESSAGE, error);
      return Promise.reject(error);
    }
  }
  @Action
  async [Actions.TUTORIAL_ITEM_RETRIEVE](tutorialId) {
    try {
      const response = await ApiService.get(
        "tutorial/" + tutorialId + "/items"
      );
      return Promise.resolve(response);
    } catch (error) {
      this.context.dispatch(Actions.API_ERROR_MESSAGE, error);
      return Promise.reject(error);
    }
  }

  @Action
  async [Actions.CREATE_TUTORIAL](data) {
    try {
      const response = await ApiService.post("tutorial", data);
      return Promise.resolve(response);
    } catch (error) {
      this.context.dispatch(Actions.API_ERROR_MESSAGE, error);
      return Promise.reject(error);
    }
  }
  @Action
  async [Actions.UPDATE_TUTORIAL]({ tutorialId, data }) {
    try {
      const response = await ApiService.put(`tutorial/${tutorialId}`, data);
      return Promise.resolve(response);
    } catch (error) {
      this.context.dispatch(Actions.API_ERROR_MESSAGE, error);
      return Promise.reject(error);
    }
  }

  @Action
  async [Actions.CREATE_TUTORIAL_ITEM]({ tutorialId, data }) {
    try {
      const response = await ApiService.post(
        `tutorial/${tutorialId}/items`,
        data
      );
      return Promise.resolve(response);
    } catch (error) {
      this.context.dispatch(Actions.API_ERROR_MESSAGE, error);
      return Promise.reject(error);
    }
  }

  @Action
  async [Actions.DELETE_TUTORIAL](tutorialId) {
    try {
      const response = await ApiService.delete("tutorial/" + tutorialId);
      return Promise.resolve(response);
    } catch (error) {
      this.context.dispatch(Actions.API_ERROR_MESSAGE, error);
      return Promise.reject(error);
    }
  }

  @Action
  async [Actions.DELETE_TUTORIAL_ITEM](tutorialItemId) {
    try {
      const response = await ApiService.delete(
        "tutorial/tutorialItem/" + tutorialItemId
      );
      return Promise.resolve(response);
    } catch (error) {
      this.context.dispatch(Actions.API_ERROR_MESSAGE, error);
      return Promise.reject(error);
    }
  }
}
